import React from "react";
import { AiFillMinusCircle } from "@react-icons/all-files/ai/AiFillMinusCircle";
import { BsPlusCircleFill } from "@react-icons/all-files/bs/BsPlusCircleFill";

import { classNames } from "repoV2/utils/common/render/classNames";

import { ButtonV2 } from "@Modules/common/ButtonV2";
import { ITicketCount } from "./TicketCount";

import styles from "./ticketCount.module.scss";
import useTicketCount from "./useTicketCount";

const TicketCount = (props: ITicketCount.IProps) => {
    const { bottomSibling } = props;

    const {
        hideComponent,
        decreaseQty,
        disableDecreaseQty,
        increaseQty,
        disableIncreaseQty,
        quantityTitle,
    } = useTicketCount(props);

    if (hideComponent) return null;

    return (
        <>
            <div className={styles.root}>
                <div className={styles.title}>Booking For</div>

                <div className={classNames(styles.qtyContainer)}>
                    <ButtonV2
                        className={classNames(styles.reduceQty)}
                        disabled={disableDecreaseQty}
                        onClick={decreaseQty}
                    >
                        <AiFillMinusCircle />
                    </ButtonV2>

                    <div className={styles.quantity}>{quantityTitle}</div>

                    <ButtonV2
                        className={classNames(styles.increaseQty)}
                        disabled={disableIncreaseQty}
                        onClick={increaseQty}
                    >
                        <BsPlusCircleFill />
                    </ButtonV2>
                </div>
            </div>
            {bottomSibling}
        </>
    );
};

export default TicketCount;
